import { StrapiImageAsset } from "@/components/StrapiImageAsset";
import { basierCirleBold } from "@/styles/fonts";
import theme from "@/styles/theme";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import { grey } from "@mui/material/colors";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Link from "next/link";
import { useState } from "react";
import { FormattedDate } from "react-intl";
import { CategoryTag } from "../CategoryTag";

export const DevelopmentProgramEntry = ({ program, onExpandChanged }) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = (event) => {
    setExpanded(!expanded);

    if (onExpandChanged) {
      onExpandChanged(!expanded);
    }
  };

  return (
    <>
      <Grid
        key={program.id}
        id={`${program.slug}`}
        item
        sm={6}
        md={4}
        sx={{
          [theme.breakpoints.down("md")]: {
            display: "none",
          },
          "& img": {
            mixBlendMode: "multiply",
          },
        }}
      >
        <StrapiImageAsset
          strapiImageObject={program.logo}
          layout="responsive"
          objectFit="contain"
          objectPosition="left"
          width={160}
          height={90}
          fixedHeight={true}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              component="p"
              sx={{
                fontWeight: basierCirleBold.style.fontWeight,
                fontFamily: basierCirleBold.style.fontFamily,
                textTransform: "uppercase",
                color: theme.palette.common.black,
              }}
            >
              {program.title}{" "}
              <CategoryTag
                text={program.category.name}
                variant={`category--${program.category.name}`}
                color={program.category.color}
              />
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              [theme.breakpoints.up("md")]: {
                display: "none",
              },
            }}
          >
            <StrapiImageAsset
              strapiImageObject={program.logo}
              layout="responsive"
              objectFit="contain"
              objectPosition="left"
              width={160}
              height={90}
              fixedHeight={true}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="body1"
              sx={{
                "&.MuiTypography-root": {
                  fontSize: ".875rem",
                  fontWeight: basierCirleBold.style.fontWeight,
                  fontFamily: basierCirleBold.style.fontFamily,
                  textTransform: "uppercase",
                  color: theme.palette.common.black,
                },
              }}
            >
              Für wen
            </Typography>
            <Typography variant="body1">{program.targetgroup}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Button
              color="secondary"
              variant="outlined"
              expand={expanded}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="Mehr Infos anzeigen"
            >
              {expanded ? `Weniger Infos` : "Mehr Infos"}
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Collapse
        in={expanded}
        timeout="auto"
        unmountOnExit
        sx={{
          "&.MuiCollapse-root": {
            padding: 0,
          },
        }}
      >
        <Box
          sx={{
            backgroundColor: grey[100],
            px: 3,
            pt: 2,
          }}
        >
          <Grid container spacing={2} sx={{ justifyContent: "flex-end" }}>
            <Grid item xs={12} md={8}>
              <Grid
                container
                spacing={2}
                sx={{
                  "& .MuiGrid-root": {
                    "& .MuiTypography-root": {
                      "&:nth-of-type(odd)": {
                        fontWeight: basierCirleBold.style.fontWeight,
                        fontFamily: basierCirleBold.style.fontFamily,
                        textTransform: "uppercase",
                        fontSize: ".875rem",
                      },
                    },
                  },
                }}
              >
                {program.region?.name && (
                  <Grid item xs={12}>
                    <Typography variant="body1">Region</Typography>
                    <Typography variant="body1">
                      {program.region?.name}
                    </Typography>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Typography variant="body1">Worum geht&apos;s?</Typography>
                  <Typography variant="body1">{program.description}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body1">
                    Ausschreibende Fördereinrichtung
                  </Typography>
                  <Typography variant="body1">{program.funding}</Typography>
                </Grid>
                {program.deadline ? (
                  <Grid item xs={12}>
                    <Typography variant="body1">Antragsfrist</Typography>
                    <Typography variant="body1">
                      <FormattedDate value={program.deadline} />
                    </Typography>
                  </Grid>
                ) : (
                  <Grid item xs={12}>
                    <Typography variant="body1">Antragsfrist</Typography>
                    <Typography variant="body1">Fortlaufend</Typography>
                  </Grid>
                )}
                <Grid item xs={12}>
                  {program.type == "others" ? (
                    <Box>
                      <Typography variant="body1" sx={{ mb: 1 }}>
                        Weitere Infos & Anmeldung
                      </Typography>
                      <Button
                        component={Link}
                        href={program.link}
                        color="secondary"
                        variant="contained"
                      >
                        Zur Website
                      </Button>
                    </Box>
                  ) : (
                    <Button
                      component="a"
                      href="https://www.create-music.info/foerderung/"
                      target="_blank"
                      rel="noopener noreferrer"
                      color="secondary"
                      variant="outlined"
                    >
                      Zur Website
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Collapse>
    </>
  );
};
